import { render, staticRenderFns } from "./DrivewealthDocumentsPage.vue?vue&type=template&id=49de0db2"
import script from "./DrivewealthDocumentsPage.vue?vue&type=script&lang=ts"
export * from "./DrivewealthDocumentsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports